const eventCategory = "DIY_N_Price";

export const addBankClicked = {
    eventCategory,
    eventAction: "Add bank account button clicked"
};
export const uploadDocumentClicked = {
    eventCategory,
    eventAction: "upload document button clicked"
};
